/**
 * Where an Instance Advice button goes — one place for the address and what
 * travels with it, so Manage Portfolio, Telemetry, the cloud-credential view
 * and the sidebar all open the advice the same way.
 *
 *   navigate(...adviceLink(portfolioId, { discount, headroom }));
 *
 * The discount and margin on screen are handed over (navigation state) so
 * the advice matches what the user just saw — legacy read them from the store.
 * `discount` is the contract discount's UI value ({ onDemand, oneYearRi,
 * threeYearRi }); the Cost Advice page reads it as state.advice.discount.
 * Pure: no React, no router.
 */
export const ADVICE_PATH = '/cost-advice';

/**
 * @param {string} portfolioId
 * @param {{ discount?: { onDemand, oneYearRi, threeYearRi }, headroom?: number }} [handover]
 * @returns {[string, { state?: object }]} arguments for navigate()
 */
export function adviceLink(portfolioId, handover) {
  const to = `${ADVICE_PATH}?portfolioId=${encodeURIComponent(portfolioId ?? '')}`;
  return handover ? [to, { state: { advice: handover } }] : [to, {}];
}
